import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = {
  key: 0,
  id: "layout-banner"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "carousel-img",
  src: "https://static.web.sdo.com/mxd/pic/wiki/test-banner.png"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "container" }

import { NConfigProvider, GlobalThemeOverrides } from "naive-ui";
import { zhCN, dateZhCN } from "naive-ui";
import Banner from "components/Banner";
import Nav from "components/Nav";
// import { isMobile } from "@/libs/tool";

import SideBar from "components/Side-bar/index.vue";
import { useRoute } from "vue-router";
import {} from "vue";
import themeOverrides from "config/themeOverrides";

// console.log(parentRouteFilter(localRoutes));


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
// const im: boolean = isMobile();
// const meta = route.meta;

// const themeOverrides: GlobalThemeOverrides = {
//   common: {
//     primaryColor: "#ffb516",
//   },
//   Button: {
//     textColor: "#ffb516",
//   },
//   // Tabs: {
//   //   "tabTextColorActiveLine": "#000000FF",
//   //   "barColor": "#ffb516FF",
//   //   "tabTextColorActiveCard": "#ffb516FF",
//   //   "tabTextColorHoverBar": "#ffb516FF",
//   //   "tabTextColorActiveBar": "#ffb516FF"
//   // },
//   Calendar: {
//     borderColor: "rgba(255, 255, 255, 1)",
//     dateColorCurrent: "#ffc445FF",
//     barColor: "#ffc445FF",
//     fontSize: "18px",
//     dayTextColor: "rgba(194, 194, 194, 0)",
//   },
//   Select: {
//     peers: {
//       InternalSelection: {
//         textColor: "#ffb516",
//       },
//     },
//   },
//   // ...
// };

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NConfigProvider), {
      "theme-overrides": _unref(themeOverrides),
      locale: _unref(zhCN),
      "date-locale": _unref(dateZhCN)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Nav)),
          (_unref(route).meta.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_view)
          ])
        ])
      ]),
      _: 1
    }, 8, ["theme-overrides", "locale", "date-locale"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(SideBar)))
  ], 64))
}
}

})